import { z } from 'zod';
import { slugSchema } from './common.js';
export const serviceCreateSchema = z.object({
    slug: slugSchema,
    title: z.string().min(1).max(200).trim(),
    description: z.string().min(1).max(2000).trim(),
    icon: z.string().max(200).nullable().optional(),
    order: z.number().int().min(0).default(0),
    isPublished: z.boolean().default(true),
});
export const serviceUpdateSchema = serviceCreateSchema.partial();
export const serviceSchema = z.object({
    id: z.string(),
    slug: z.string(),
    title: z.string(),
    description: z.string(),
    icon: z.string().nullable(),
    order: z.number().int(),
    isPublished: z.boolean(),
});
//# sourceMappingURL=service.js.map